import api from 'api'

export async function downloadListingFunnelExport(
  listingId: number,
  eventType: string,
  timeRange: { startDate: string; endDate: string }
) {
  const response = await api.get<Blob>(
    `/admin/listing/${listingId}/funnel/export`,
    {
      params: {
        eventType,
        startDate: timeRange.startDate,
        endDate: timeRange.endDate,
      },
      responseType: 'blob',
    }
  )

  const contentDisposition = response.headers['content-disposition']
  const filenameMatch = contentDisposition?.match(/filename="?([^"]+)"?/)
  const filename =
    filenameMatch?.[1] ?? `listing_${listingId}_${eventType}_funnel_users.csv`

  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
